/* @jsx h */
import { defineComponent, ref, onMounted, h, Ref, computed } from "vue";

import { TableStatus, Reservation } from "@lemmonhq/types";
import { Loading } from "@app/vue/components/UIComponents";
import { FloorPlan } from "@lemmonhq/types";
import { TablesFloorplan } from "./components/FloorPlan";
import { DropModeState } from "../tables-types";
import {
  isActiveTableStatus,
  byStartTime,
} from "../../../utils/reservationStatus";
//
export const TablesFloorPlanView = defineComponent<{
  floorPlans: Ref<FloorPlan[]>;
  tables: Ref<TableStatus[]>;
  activeFloorPlan: Ref<string | undefined>;
  currentFloorPlan: Ref<FloorPlan | null>;
  onFloorPlanChange: (fp: FloorPlan) => void;
  onTablePayment: Function;
  isEditable: boolean;
  isLoading: Ref<boolean>;
  dropModeState?: Ref<DropModeState>;
  onTableClickInDropMode?: (tableId: number) => void;
  reservations?: Ref<Reservation[]>;
  isLiveDay?: boolean;
  nowMs: number;
}>({
  name: "TablesFloorPlanView",
  props: [
    "floorPlans",
    "tables",
    "activeFloorPlan",
    "currentFloorPlan",
    "onFloorPlanChange",
    "onTablePayment",
    "isEditable",
    "isLoading",
    "dropModeState",
    "onTableClickInDropMode",
    "reservations",
    "isLiveDay",
    "nowMs",
  ],
  setup(props) {
    const { tables } = props;
    const loading = ref(true);

    // Bucket the day's reservations by table id ONCE for the whole floor
    // (active statuses only, time-sorted), so each cell looks up its slice in
    // O(1) instead of every cell re-scanning the full reservations array.
    const reservationsByTable = computed(() => {
      const map = new Map<number, Reservation[]>();
      for (const r of props.reservations?.value || []) {
        if (!isActiveTableStatus(r.status)) continue;
        for (const a of r.table_assignments || []) {
          const id = Number(a.table_id);
          const arr = map.get(id);
          if (arr) arr.push(r);
          else map.set(id, [r]);
        }
      }
      for (const arr of map.values()) arr.sort(byStartTime);
      return map;
    });

    const fetchTables = async () => {
      try {
        console.log("props", props);
        // Floor plan is now managed by parent component
      } catch (error) {
        console.error("Failed to fetch tables:", error);
      } finally {
        loading.value = false;
      }
    };

    onMounted(() => {
      fetchTables();
    });

    return () => {
      if (loading.value) {
        return (
          <div class="w-full h-full flex-1 flex justify-center items-center">
            <Loading />
          </div>
        );
      }

      return (
        <div
          class="px-0 h-full overflow-hidden flex flex-col"
          style={`background: ${props.currentFloorPlan.value?.color || "var(--floor-plan-background)"}`}
        >
          <style>{`
            .floor-plan-transition {
              animation: roomFadeIn 0.12s ease both;
            }
            @keyframes roomFadeIn {
              from { opacity: 0; }
              to { opacity: 1; }
            }
          `}</style>
          <div class="flex flex-1 flex flex-col pb-0 relative">
            {props.currentFloorPlan.value ? (
              <div
                key={props.currentFloorPlan.value.id}
                class="flex-1 flex flex-col floor-plan-transition"
              >
                <TablesFloorplan
                  tables={tables.value}
                  floorPlan={props.currentFloorPlan.value}
                  onFloorPlanChange={props.onFloorPlanChange}
                  onPayment={props.onTablePayment}
                  isEditable={props.isEditable}
                  isLoading={props.isLoading}
                  dropModeState={props.dropModeState}
                  onTableClickInDropMode={props.onTableClickInDropMode}
                  reservations={props.reservations?.value || []}
                  reservationsByTable={reservationsByTable.value}
                  isLiveDay={props.isLiveDay}
                  nowMs={props.nowMs}
                />
              </div>
            ) : null}
          </div>
        </div>
      );
    };
  },
});
